"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

var _react = _interopRequireWildcard(require("react"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _background = _interopRequireDefault(require("./assets/background.jpg"));

var _mod_barrel = _interopRequireDefault(require("./assets/mod_barrel.png"));

var _mod_bipod = _interopRequireDefault(require("./assets/mod_bipod.png"));

var _mod_catch = _interopRequireDefault(require("./assets/mod_catch.png"));

var _mod_chamber = _interopRequireDefault(require("./assets/mod_chamber.png"));

var _mod_charge = _interopRequireDefault(require("./assets/mod_charge.png"));

var _mod_equipment = _interopRequireDefault(require("./assets/mod_equipment.png"));

var _mod_flashlight = _interopRequireDefault(require("./assets/mod_flashlight.png"));

var _mod_foregrip = _interopRequireDefault(require("./assets/mod_foregrip.png"));

var _mod_gas_block = _interopRequireDefault(require("./assets/mod_gas_block.png"));

var _mod_hammer = _interopRequireDefault(require("./assets/mod_hammer.png"));

var _mod_handguard = _interopRequireDefault(require("./assets/mod_handguard.png"));

var _mod_launcher = _interopRequireDefault(require("./assets/mod_launcher.png"));

var _mod_mag_shaft = _interopRequireDefault(require("./assets/mod_mag_shaft.png"));

var _mod_magazine = _interopRequireDefault(require("./assets/mod_magazine.png"));

var _mod_mount = _interopRequireDefault(require("./assets/mod_mount.png"));

var _mod_muzzle = _interopRequireDefault(require("./assets/mod_muzzle.png"));

var _mod_nvg = _interopRequireDefault(require("./assets/mod_nvg.png"));

var _mod_pistol_grip = _interopRequireDefault(require("./assets/mod_pistol_grip.png"));

var _mod_reciever = _interopRequireDefault(require("./assets/mod_reciever.png"));

var _mod_scope = _interopRequireDefault(require("./assets/mod_scope.png"));

var _mod_sight_front = _interopRequireDefault(require("./assets/mod_sight_front.png"));

var _mod_sight_rear = _interopRequireDefault(require("./assets/mod_sight_rear.png"));

var _mod_silencer = _interopRequireDefault(require("./assets/mod_silencer.png"));

var _mod_stock = _interopRequireDefault(require("./assets/mod_stock.png"));

var _mod_tactical = _interopRequireDefault(require("./assets/mod_tactical.png"));

var _mod_trigger = _interopRequireDefault(require("./assets/mod_trigger.png"));

require("./index.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Slot(_ref) {
  let {
    type,
    onSelect,
    onItemDeselect,
    item,
    possibleItemsConflicts
  } = _ref;
  const [display, setDisplay] = (0, _react.useState)(false);
  let conflict = undefined;

  const showButton = e => {
    e.preventDefault();
    setDisplay(true);
  };

  const hideButton = e => {
    e.preventDefault();
    setDisplay(false);
  };

  (0, _react.useEffect)(() => {
    _reactTooltip.default.rebuild();
  });

  if (item) {
    possibleItemsConflicts.forEach(slotItemSet => {
      slotItemSet.ids.forEach(id => {
        if (id === (item === null || item === void 0 ? void 0 : item.id)) {
          conflict = slotItemSet.item.name;
        }
      });
    });
  }

  let image = _background.default;

  if (type.includes('barrel')) {
    image = _mod_barrel.default;
  } else if (type.includes('mod_bipod')) {
    image = _mod_bipod.default;
  } else if (type.includes('mod_catch')) {
    image = _mod_catch.default;
  } else if (type.includes('mod_chamber')) {
    image = _mod_chamber.default;
  } else if (type.includes('mod_charge')) {
    image = _mod_charge.default;
  } else if (type.includes('mod_equipment')) {
    image = _mod_equipment.default;
  } else if (type.includes('mod_flashlight')) {
    image = _mod_flashlight.default;
  } else if (type.includes('mod_foregrip')) {
    image = _mod_foregrip.default;
  } else if (type.includes('mod_gas_block')) {
    image = _mod_gas_block.default;
  } else if (type.includes('mod_hammer')) {
    image = _mod_hammer.default;
  } else if (type.includes('mod_handguard')) {
    image = _mod_handguard.default;
  } else if (type.includes('mod_launcher')) {
    image = _mod_launcher.default;
  } else if (type.includes('mod_mag_shaft')) {
    image = _mod_mag_shaft.default;
  } else if (type.includes('mod_magazine')) {
    image = _mod_magazine.default;
  } else if (type.includes('mod_mount')) {
    image = _mod_mount.default;
  } else if (type.includes('mod_muzzle')) {
    image = _mod_muzzle.default;
  } else if (type.includes('mod_nvg')) {
    image = _mod_nvg.default;
  } else if (type.includes('mod_pistol_grip')) {
    image = _mod_pistol_grip.default;
  } else if (type.includes('mod_reciever')) {
    image = _mod_reciever.default;
  } else if (type.includes('mod_scope')) {
    image = _mod_scope.default;
  } else if (type.includes('mod_sight_front')) {
    image = _mod_sight_front.default;
  } else if (type.includes('mod_sight_rear')) {
    image = _mod_sight_rear.default;
  } else if (type.includes('mod_silencer')) {
    image = _mod_silencer.default;
  } else if (type.includes('mod_stock')) {
    image = _mod_stock.default;
  } else if (type.includes('mod_tactical')) {
    image = _mod_tactical.default;
  } else if (type.includes('mod_trigger')) {
    image = _mod_trigger.default;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "tgb-slot ".concat(conflict && 'tgb-conflict'),
    children: [item && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "data-for": type,
      "data-tip": "Cannot install both '".concat(item.name, "' and '").concat(conflict, "' at the same time"),
      className: "tgb-slot-item-wrapper",
      onMouseEnter: e => showButton(e),
      onMouseLeave: e => hideButton(e),
      children: [display && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: onItemDeselect,
        children: "\xD7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        onClick: onSelect,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          alt: item.name,
          loading: "lazy",
          src: item.iconLink
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "tgb-slot-item-name-wrapper",
          children: item.shortName
        })]
      }), conflict && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTooltip.default, {
        id: type
      })]
    }), !item && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tgb-slot-name-wrapper",
      onClick: onSelect,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        alt: 'item.name',
        loading: "lazy",
        src: _background.default
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        alt: 'item.name',
        loading: "lazy",
        src: image
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: type.replace('mod_', '').replace('_', ' ').replace('reciever', 'receiver').toUpperCase()
      })]
    })]
  });
}

var _default = Slot;
exports.default = _default;